import { Main } from './components';

const DataLoad = () => <Main />;

export default DataLoad;
